import { reportAPI } from '@/services-ts/axios'
import type { IGetAnswerWinReportEmployeeBased, IGetAnswerWinReportExcel } from '@/types/Request'
import type { IAnswerWinReportStore } from '@/types/Store/State'
import { defineStore } from 'pinia'

export const useAnswerWinReportStore = defineStore('answerWinReport', {
  state: (): IAnswerWinReportStore => ({
    answerWinReportList: {
      employeeBasedReports: {
        total: 0,
        data: [],
      },
      questionBasedReports: [],
      totalSuccessRate: 0,
    },
    questionBasedReportsDetail: null,
  }),

  actions: {
    async GetAnswerWinReportEmployeeBased(payload: IGetAnswerWinReportEmployeeBased) {
      const { status, data, total } =
        await reportAPI.AnswerWinReportServices.GetAnswerWinReportEmployeeBased(payload)

      if (status && data) {
        if (payload.Skip === 0 || (total || 0) > 0) {
          this.answerWinReportList.employeeBasedReports.total = total || 0
        }
        this.answerWinReportList.employeeBasedReports.data = data.items || []

        if (payload.Skip === 0 || data.totalSuccessRate > 0) {
          this.answerWinReportList.totalSuccessRate = data.totalSuccessRate
        }
      } else {
        this.answerWinReportList.employeeBasedReports = { total: 0, data: [] }
      }
    },

    async GetAnswerWinReportQuestionBased(answerWinId: string) {
      const { status, data } =
        await reportAPI.AnswerWinReportServices.GetAnswerWinReportQuestionBased(answerWinId)

      this.answerWinReportList.questionBasedReports = status ? data : []
    },

    async GetAnswerWinReportQuestionBasedDetail(questionId: string) {
      const { status, data } =
        await reportAPI.AnswerWinReportServices.GetAnswerWinReportQuestionBasedDetail(questionId)

      this.questionBasedReportsDetail = status ? data : null
    },

    async GetAnswerWinReportEmployeeBasedExcel(payload: IGetAnswerWinReportExcel) {
      await reportAPI.AnswerWinReportServices.GetAnswerWinReportEmployeeBasedExcel(payload)
    },

    async GetAnswerWinReportQuestionBasedExcel(payload: IGetAnswerWinReportExcel) {
      await reportAPI.AnswerWinReportServices.GetAnswerWinReportQuestionBasedExcel(payload)
    },
  },
})
